import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a6f3745e"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6f3745e')) {
      api.createRecord('a6f3745e', component.options)
    } else {
      api.reload('a6f3745e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a6f3745e", function () {
      api.rerender('a6f3745e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/index.vue"
export default component.exports